var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBankTransfer = function SvgBankTransfer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 27.1875H24.5625",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 23.9375H24.5625",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 12.5625V20.6875",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5625 9.31248H1.8125L12.31 3.07248C12.5718 2.90449 12.8764 2.81519 13.1875 2.81519C13.4986 2.81519 13.8032 2.90449 14.065 3.07248L24.5625 9.31248Z",
    stroke: "#0357FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6429,
    cy: 4.64286,
    rx: 4.64286,
    ry: 4.64286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6429 0C11.7246 0 10.8269 0.272299 10.0634 0.782463C9.29991 1.29263 8.70483 2.01774 8.35342 2.86611C8.00201 3.71448 7.91007 4.64801 8.08921 5.54863C8.26836 6.44926 8.71055 7.27654 9.35986 7.92585C10.0092 8.57517 10.8365 9.01736 11.7371 9.1965C12.6377 9.37565 13.5712 9.28371 14.4196 8.9323C15.268 8.58089 15.9931 7.98581 16.5033 7.22229C17.0134 6.45878 17.2857 5.56113 17.2857 4.64286C17.2857 3.4115 16.7966 2.23057 15.9259 1.35986C15.0552 0.489157 13.8742 0 12.6429 0V0ZM13.1391 7.38505V7.7942C13.1391 7.9258 13.0868 8.05201 12.9937 8.14507C12.9007 8.23812 12.7745 8.2904 12.6429 8.2904C12.5113 8.2904 12.385 8.23812 12.292 8.14507C12.1989 8.05201 12.1467 7.9258 12.1467 7.7942V7.38505C11.8505 7.29044 11.5867 7.11514 11.3847 6.87883C11.1827 6.64251 11.0507 6.35456 11.0034 6.04732C10.9841 5.91687 11.0175 5.78413 11.0961 5.67828C11.1747 5.57244 11.2922 5.50216 11.4227 5.48292C11.5531 5.46368 11.6859 5.49705 11.7917 5.57569C11.8975 5.65432 11.9678 5.77179 11.9871 5.90223C12.0138 6.06631 12.1011 6.21441 12.2317 6.3173C12.3622 6.42018 12.5266 6.47039 12.6924 6.458C12.8582 6.44561 13.0133 6.37153 13.1272 6.25038C13.241 6.12923 13.3053 5.9698 13.3074 5.80357C13.3063 5.70439 13.2764 5.60767 13.2212 5.52522C13.1661 5.44277 13.0881 5.37817 12.9969 5.33929L11.8971 4.86339C11.6261 4.7485 11.395 4.55612 11.2329 4.31039C11.0708 4.06466 10.9849 3.77652 10.9859 3.48214C10.9858 3.1293 11.0983 2.78562 11.3071 2.50117C11.5159 2.21672 11.81 2.00634 12.1467 1.90067V1.49152C12.1467 1.35992 12.1989 1.2337 12.292 1.14065C12.385 1.04759 12.5113 0.995313 12.6429 0.995313C12.7745 0.995313 12.9007 1.04759 12.9937 1.14065C13.0868 1.2337 13.1391 1.35992 13.1391 1.49152V1.90067C13.4352 1.99527 13.699 2.17058 13.901 2.40689C14.103 2.6432 14.235 2.93115 14.2824 3.23839C14.3015 3.36844 14.2682 3.50075 14.1899 3.60629C14.1115 3.71183 13.9945 3.78198 13.8645 3.80134C13.8009 3.81169 13.7358 3.8094 13.673 3.79458C13.6103 3.77976 13.5511 3.7527 13.4988 3.71497C13.4465 3.67723 13.4022 3.62956 13.3683 3.57467C13.3345 3.51978 13.3118 3.45876 13.3016 3.39509C13.2748 3.23101 13.1875 3.08291 13.057 2.98003C12.9264 2.87714 12.762 2.82694 12.5962 2.83932C12.4304 2.85171 12.2753 2.92579 12.1614 3.04694C12.0476 3.1681 11.9833 3.32752 11.9813 3.49375C11.9814 3.59351 12.0109 3.69102 12.0661 3.77411C12.1214 3.85719 12.1998 3.92217 12.2917 3.96094L13.3915 4.43393C13.6602 4.54849 13.8894 4.73927 14.0508 4.98269C14.2122 5.22611 14.2988 5.5115 14.2998 5.80357C14.2999 6.15642 14.1874 6.50009 13.9786 6.78454C13.7698 7.069 13.4757 7.27938 13.1391 7.38505Z",
    fill: "#0357FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.28571,
    height: 9.28572,
    fill: "white",
    transform: "translate(8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bankTransfer.5189aa7f.svg";
export { ForwardRef as ReactComponent };